import { DeleteApi, GetApi, PostApi, PutApi } from './api';

const buildQuery = (params) => {
  if (!params) return '';
  const filtered = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  );
  const qs = new URLSearchParams(filtered).toString();
  return qs ? `?${qs}` : '';
};

export const getEquipments = (params, isHeader = true) => {
  return GetApi(`admin/v1/equipment${buildQuery(params)}`, isHeader).then((response) => {
    return response.data;
  });
};

export const getExercises = (params, isHeader = true) => {
  return GetApi(`admin/v1/exercises${buildQuery(params)}`, isHeader).then((response) => {
    return response.data;
  });
};

export const getExerciseById = (exerciseId, isHeader = true) => {
  return GetApi(`admin/v1/exercises/${exerciseId}`, isHeader).then((response) => {
    return response.data;
  });
};

export const deleteExercise = (exerciseId, isHeader = true) => {
  return DeleteApi(`admin/v1/exercises/${exerciseId}`, isHeader).then((response) => {
    return response.data;
  });
};

export const createEquipment = (payload, isHeader = true) => {
  return PostApi('admin/v1/equipment', payload, isHeader).then((response) => {
    return response.data;
  });
};

export const getEquipmentById = (equipmentId, isHeader = true) => {
  return GetApi(`admin/v1/equipment/${equipmentId}`, isHeader).then((response) => {
    return response.data;
  });
};

export const updateEquipment = (equipmentId, payload, isHeader = true) => {
  return PutApi(`admin/v1/equipment/${equipmentId}`, payload, isHeader).then((response) => {
    return response.data;
  });
};

export const deleteEquipment = (equipmentId, isHeader = true) => {
  return DeleteApi(`admin/v1/equipment/${equipmentId}`, isHeader).then((response) => {
    return response.data;
  });
};

export const getExerciseCategories = (params, isHeader = true) => {
  return GetApi(`admin/v1/getCategoriesByContentIdPopulate/31${buildQuery(params)}`, isHeader).then(
    (response) => {
      return response.data;
    }
  );
};

export const createExerciseCategory = (payload, isHeader = true) => {
  return PostApi('admin/v1/createCategoryforContent', payload, isHeader).then((response) => {
    return response.data;
  });
};
export const deleteExerciseCategory = (categoryId, isHeader = true) => {
  //will not work
  return PutApi(`admin/v1/removeCategoryforContent`, { categoryId }, isHeader).then((response) => {
    return response.data;
  });
};
export const saveExercise = (payload, isHeader = true) => {
  return PostApi('admin/v1/exercises', payload, isHeader).then((response) => {
    return response.data;
  });
};
export const updateExercise = (exerciseId, payload, isHeader = true) => {
  return PutApi(`admin/v1/exercises/${exerciseId}`, payload, isHeader).then((response) => {
    return response.data;
  });
};
export const createWorkout = (payload, isHeader = true) => {
  return PostApi('admin/v1/workout', payload, isHeader).then((response) => {
    return response.data;
  });
};

export const createWorkoutPlan = (payload, isHeader = true) => {
  return PostApi('admin/v1/workout-plan', payload, isHeader).then((response) => {
    return response.data;
  });
};

export const updateWorkout = (workoutId, payload, isHeader = true) => {
  return PutApi(`admin/v1/workout/${workoutId}`, payload, isHeader).then((response) => {
    return response.data;
  });
};

export const deleteWorkout = (workoutId, isHeader = true) => {
  return DeleteApi(`admin/v1/workout/${workoutId}`, isHeader).then((response) => {
    return response.data;
  });
};

export const updateWorkoutPlan = (workoutPlanId, payload, isHeader = true) => {
  return PutApi(`admin/v1/workout-plan/${workoutPlanId}`, payload, isHeader).then((response) => {
    return response.data;
  });
};

export const getWorkouts = (params, isHeader = true) => {
  return GetApi(`admin/v1/workout${buildQuery(params)}`, isHeader).then((response) => {
    return response.data;
  });
};
export const getWorkoutOverview = (isHeader = true) => {
  return GetApi(`admin/v1/workout/overview`, isHeader).then((response) => {
    return response.data;
  });
};
export const getWorkoutStats = (isHeader = true) => {
  return GetApi(`admin/v1/workout/stats`, isHeader).then((response) => {
    return response.data;
  });
};
export const getRecipeeOverview = (isHeader = true) => {
  return GetApi(`admin/v1/recipes/overview`, isHeader).then((response) => {
    return response.data;
  });
};
export const getRecipeStats = (isHeader = true) => {
  return GetApi(`admin/v1/recipes/stats`, isHeader).then((response) => {
    return response.data;
  });
};

export const getWorkoutPlans = (params, isHeader = true) => {
  return GetApi(`admin/v1/workout-plan${buildQuery(params)}`, isHeader).then((response) => {
    return response.data;
  });
};
export const getRecipe = (params, isHeader = true) => {
  return GetApi(`admin/v1/recipes${buildQuery(params)}`, isHeader).then((response) => {
    return response.data;
  });
};

export const getWorkoutById = (workoutId, isHeader = true) => {
  return GetApi(`admin/v1/workout/${workoutId}`, isHeader).then((response) => {
    return response.data;
  });
};

export const createRecipe = (payload, isHeader = true) => {
  return PostApi('admin/v1/recipes', payload, isHeader).then((response) => {
    return response.data;
  });
};

export const updateRecipe = (recipeId, payload, isHeader = true) => {
  return PutApi(`admin/v1/recipes/${recipeId}`, payload, isHeader).then((response) => {
    return response.data;
  });
};

export const deleteRecipe = (recipeId, isHeader = true) => {
  return DeleteApi(`admin/v1/recipes/${recipeId}`, isHeader).then((response) => {
    return response.data;
  });
};
export const getRecipeById = (recipeId, isHeader = true) => {
  return GetApi(`admin/v1/recipes/${recipeId}`, isHeader).then((response) => {
    return response.data;
  });
};

export const getWorkoutPlanById = (workoutPlanId, isHeader = true) => {
  return GetApi(`admin/v1/workout-plan/${workoutPlanId}`, isHeader).then((response) => {
    return response.data;
  });
};

export const getLastPuffDashboard = (isHeader = true) => {
  return GetApi(`admin/v1/lastpuff/dashboard`, isHeader).then((response) => {
    return response.data;
  });
};

export const getLastDrinkDashboard = (isHeader = true) => {
  return GetApi(`admin/v1/lastdrink/dashboard`, isHeader).then((response) => {
    return response.data;
  });
};

export const getEliteAthleteStats = (isHeader = true) => {
  return GetApi(`admin/v1/elite-athlete-stats`, isHeader).then((response) => {
    return response.data;
  });
};
